import {connect} from 'react-redux'
import ReceiptForm from './ReceiptForm'
import {isDirty} from 'redux-form'
import ReceiptPreview from './ReceiptPreview'
import Header from './Header'
import {
  changeOutlet,
  pageRequest,
  submitForm,
  changePage
} from 'actions/setting/receipt'
import {askConfirmAction} from 'actions/confirm-action'
import styles from './Receipt.css'
import {browserHistory} from 'react-router'
import ConfirmActionModal from 'components/ConfirmActionModal'
import ActionBar from './ActionBar'

class Receipt extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      $('#mk-col-right').show()
      this.props.dispatch(pageRequest())
      browserHistory.listenBefore((location) => {
        if (!this.props.data.isDirtyForm) {
          this.props.dispatch(changePage(location.pathname))
        } else {
          // negate the change location, instead use sagas to handle the change location
          this.props.dispatch(askConfirmAction(changePage(location.pathname)))
        }
        return false
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    let receiptForm = (<ReceiptForm onSubmit={this._onSubmit} />)
    return (<div className={styles.wrapper}>
      <ActionBar onChangeOutlet={this._onChangeOutlet} />
      <div className={styles.container}>
        <div className={`${styles['receipt-info-wrapper']} col-sm-6`} id='mk-col-left' style={{paddingRight: 0}}>
          <Header title='Receipt info' />
          {receiptForm}
        </div>
        <div className={`${styles['receipt-preview-wrapper']} col-sm-6`} id='mk-col-right'>
          <Header title='Receipt preview' />
          <ReceiptPreview />
        </div>
      </div>
      <ConfirmActionModal />
    </div>)
  }

  _onChangeOutlet = (outletIds = []) => {
    if (this.props.data.isDirtyForm) {
      this.props.dispatch(askConfirmAction(changeOutlet(outletIds)))
    } else {
      this.props.dispatch(changeOutlet(outletIds))
    }
  };

  _onSubmit = (values) => {
    let outletId = this.props.data.outlet.currentOutlet[0].id
    let data = {
      outlet: {
        address: values.address,
        city: values.city,
        name: values.name,
        notes: values.notes,
        province: values.province,
        phone_number: '0' + values.phone,
        postal_code: values.zipcode
      }
    }
    this.props.dispatch(submitForm(outletId, data, {}))
  }
}

function mapStateToProps (state) {
  return {
    data: {
      isDirtyForm: isDirty('checkout')(state),
      outlet: state.outlet,
      subscriptionExpired: state.subscriptionExpired
    }
  }
}

export default connect(mapStateToProps)(Receipt)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Receipt/Receipt.js